import React, { useState } from "react";
import {
  Send,
  Facebook,
  PlaySquare,
  Instagram,
} from "lucide-react";
import "./FooterLinks.css";
import { getBrandName } from "../../common/brand";
import useTranslate from "../../hooks/useTranslate";

import deposit1 from "../../images/deposit1.svg";
import deposit2 from "../../images/deposit2.svg";
import deposit3 from "../../images/deposit3.svg";
import gamingLicenseImg from "../../images/GamingLicense.svg";

export default function FooterLinks() {
  const [expanded, setExpanded] = useState(true);
  const brandName = getBrandName();
  const { t } = useTranslate();

  const paymentMethods = [
    { id: "bKash", name: "bKash", src: deposit1, hot: "2%" },
    { id: "nagad", name: "Nagad", src: deposit2, hot: "5%" },
    { id: "rocket", name: "Rocket", src: deposit3, hot: "8%" },
    { id: "upay", name: "Upay", src: deposit1, hot: "8%" },
  ];

  const certifications = [
    {
      name: "iTech Labs",
      src: "../../images/footer-iTechLabs.svg",
    },
    {
      name: "Casino Analyzer",
      src: "../../images/gaming_Casino_Analyzer.svg",
    },
  ];

  const communityLogos = [
    {
      name: "18+",
      src: "../../images/safe2.png",
    },
  ];

  const gamingLicense = [
    { name: "Gaming Curacao", src: gamingLicenseImg },
  ];

  return (
    <footer className="footer-links-wrap">
      <div className="about-us-container">
        <div className={`about-content ${expanded ? "expanded" : "collapsed"}`}>
          <p>
            <strong>{t("footerAboutTitle", { brandName })}</strong>
          </p>

          <p>
            <strong>{t("footerAboutPara1", { brandName })}</strong>
          </p>

          <p>
            <strong>{t("footerAboutPara2", { brandName })}</strong>
          </p>

          <p className="divider-line">________________________________________</p>

          <p>
            <strong>{t("footerWhatMakesUsSpecial")}</strong>
          </p>

          <div className="text-block">
            <p>
              <strong>{t("footerFastDepositTitle")}</strong>
            </p>
            <p>{t("footerFastDepositDesc")}</p>

            <p>
              <strong>{t("footerSupportTitle")}</strong>
            </p>
            <p>{t("footerSupportDesc")}</p>

            <p>
              <strong>{t("footerSafeTitle")}</strong>
            </p>
            <p>{t("footerSafeDesc")}</p>

            <p>
              <strong>{t("footerGamesTitle")}</strong>
            </p>
            <p>{t("footerGamesDesc")}</p>

            <p>
              <strong>{t("footerBonusTitle")}</strong>
            </p>
            <p>{t("footerBonusDesc")}</p>
          </div>

          <p className="divider-line">________________________________________</p>

          <p>
            <strong>{t("footerVisionTitle")}</strong>
          </p>
          <p>{t("footerVisionDesc")}</p>

          <p>
            <strong>{t("footerMissionTitle")}</strong>
          </p>
          <ul className="footer-bullet-list">
            <li>{t("footerMission1")}</li>
            <li>{t("footerMission2")}</li>
            <li>{t("footerMission3")}</li>
            <li>{t("footerMission4")}</li>
          </ul>

          <p className="divider-line">________________________________________</p>

          <p>
            <strong>{t("footerWhyChooseTitle", { brandName })}</strong>
          </p>
          <ul className="footer-check-list">
            <li>{t("footerWhy1")}</li>
            <li>{t("footerWhy2")}</li>
            <li>{t("footerWhy3")}</li>
            <li>{t("footerWhy4")}</li>
            <li>{t("footerWhy5")}</li>
          </ul>

          <p className="divider-line">________________________________________</p>

          <p>
            <strong>{t("footerTrustedPartner", { brandName })}</strong>
          </p>
          <p>
            <strong>{t("footerTrustLine")}</strong>
          </p>
          <p>
            <strong>{t("footerClosingLine", { brandName })}</strong>
          </p>
        </div>

        <div className="read-more-wrapper">
          <button
            type="button"
            className="read-more-btn"
            onClick={() => setExpanded((prev) => !prev)}
          >
            {expanded ? t("readLess") : t("readMore")}
          </button>
        </div>
      </div>

      <div className="footer-links-grid">
        <div className="footer-card">
          <h3 className="footer-title">{t("paymentMethods")}</h3>
          <div className="logo-grid payment-grid">
            {paymentMethods.map((item) => (
              <div key={item.name} className="logo-box">
                <img src={item.src} alt={item.name} />
              </div>
            ))}
          </div>
        </div>

        <div className="footer-card">
          <h3 className="footer-title">{t("followUs")}</h3>
          <div className="social-row">
            <a href="/" className="social-icon" aria-label="Telegram">
              <Send size={28} strokeWidth={2.2} />
            </a>
            <a href="/" className="social-icon" aria-label="Facebook">
              <Facebook size={28} strokeWidth={2.2} />
            </a>
            <a href="/" className="social-icon" aria-label="YouTube">
              <PlaySquare size={28} strokeWidth={2.2} />
            </a>
            <a href="/" className="social-icon" aria-label="Instagram">
              <Instagram size={28} strokeWidth={2.2} />
            </a>
          </div>
        </div>

        <div className="footer-card">
          <h3 className="footer-title">{t("certifications")}</h3>
          <div className="logo-grid cert-grid">
            {certifications.map((item) => (
              <div key={item.name} className="logo-box cert-box">
                <img src={item.src} alt={item.name} />
              </div>
            ))}
          </div>
        </div>

        <div className="footer-card">
          <h3 className="footer-title">{t("communityWebsite")}</h3>
          <div className="community-wrap">
            <div className="community-left">
              {communityLogos.map((item) => (
                <div key={item.name} className="community-logo">
                  <img src={item.src} alt={item.name} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="footer-card full-width">
          <h3 className="footer-title">{t("gamingLicense")}</h3>
          <div className="license-row">
            {gamingLicense.map((item) => (
              <div key={item.name} className="license-logo">
                <img src={item.src} alt={item.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}